import PageLoader from 'app/components/PageLoader';
import PaginatedTable from 'app/components/table/PaginationTable';
import { supportServiceTableHeader } from 'app/constants/table-header-constants';
import useMallSupportService from './useMallSupportService';

const MallSupportService = () => {
  const {
    isdeleteFiltering,
    fetchMallServiceData,
    totalNumber,
    sectionObj,
    filteredData,
    handleDelete,
    handleEdit,
    pageLoading,
    currentPage,
    dataPerPage,
    pageMeta,
    pageCount,
    paginationHandler,
    navigate,
  } = useMallSupportService();

  return (
    <>
      <div className='cms-content__container'>
        <PaginatedTable
          columns={supportServiceTableHeader}
          data={filteredData}
          sectionObj={sectionObj}
          totalNumber={totalNumber}
          fulldata={filteredData}
          fetchData={fetchMallServiceData}
          currentPage={currentPage}
          dataPerPage={dataPerPage}
          pageMeta={pageMeta}
          pageCount={pageCount}
          paginationHandler={paginationHandler}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
          pageLoading={pageLoading}
          navigate={navigate}
          isdeleteFiltering={isdeleteFiltering}
        />
      </div>
      {pageLoading === true && <PageLoader pageLoading={pageLoading} />}
    </>
  );
};

export default MallSupportService;
